import styled from "@emotion/styled";

export const Wrapper = styled.section`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 84px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  background-color: white;
  gap: 60px;
`;

export const GnBButton = styled.button`
  width: 54px;
  height: 54px;
`;
